<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="title||$t('menu.timePriceFood')" center width="800px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog df-c-fs">

          <div class="left f1 df-l-c-fs">
            <div class="item mt10">
              <div class="label f-xs">{{$t('menu.customFoodPrice')}}：</div>
              <InputCustom
                :inputable="true"
                inputWidth="320"
                :inputPlaceholder="$t('menu.customFoodPricePlanceholder')"
                :inputValue="fData.price" />
            </div>
          </div>

          <div class="right f1 df-l-c-ct">
            <Keyboard :inputValue.sync="fData.price" :decimalPlaces="{us:2,hk:1}[sysEnv_x]" priceModel showDoubleZero showMinus />
          </div>
          
        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="themebtn" @click="submitDialog">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogTimefood',
  data() {
    return {
      isShowDialog: false,
      fData: {
        // name: '',
        // label: '',
        price: ''
      },
      // labelList: [],
      // costOrigin: '',

      title: '',
    }
  },
  methods: {
    // open(costOrigin) {
    open(title) {
      // this.costOrigin = costOrigin
      this.title = title
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      // this.fData.name = ''
      // this.fData.label = ''
      this.title = ''
      this.fData.price = ''
      this.$emit('close')
    },

    // offClick(num) {
    //   // console.log(`%c:`, 'color: #00f;', this.costOrigin / 10 * (10 - num))
    //   // this.fData.name = this.$t('menu.off' + num)
    //   this.fData.price = (0 - this.costOrigin / 10 * (10 - num)).toFixed(0)
    //   // this.$emit('submitDialog', JSON.parse(JSON.stringify(this.fData)))
    //   // this.close()
    // },
    submitDialog() {
      // this.fData.name === '' && (this.fData.name = this.$t('menu.customFood'))
      this.$emit('submitDialog', JSON.parse(JSON.stringify(this.fData)))
      this.close()
    },
    // async getLabels() {
    //   if (this.currentShopId) {
    //     const _R = await this.getData('label', { shopId: this.currentShopId })
    //     console.log(`%c标签:`, 'color: #f00;', _R)
    //     this.labelList = _R.map(x => ({
    //       label: x.printerLabel,
    //       value: x.printerLabel
    //     }))
    //   }
    // },
  },
  // watch: {
  //   currentShopId() {
  //     this.getLabels()
  //   }
  // },
  // created() {
  //   this.getLabels()
  // },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 20px 40px 0;
  .left{
    .item{
      .label{line-height: 36px;}
      .myinput{
        width: 320px;height: 50px;line-height: 50px;
        padding: 0 14px;
        background: #fff;
        border-radius: 4px;
        box-sizing: border-box;
        border: 1px solid #374978;
      }
      .myinput,
      .myinput::placeholder{
        font-size: 14px;
        color: #606266;
      }
    }
  }
}
</style>